<script>
import JSConfetti from 'js-confetti';

export default {
    props: {
        // js-confetti puts its canvas on the body at z-index 1000, which is
        // below our overlays. Raise it when firing from inside a modal.
        zIndex: {
            type: [String, Number],
            default: 1000,
        },
    },
    mounted() {
        const canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.zIndex = String(this.zIndex);
        canvas.style.pointerEvents = 'none';
        document.body.appendChild(canvas);

        const jsConfetti = new JSConfetti({ canvas });

        jsConfetti
            .addConfetti({
                confettiRadius: 6,
                confettiNumber: 500,
                confettiColors: [
                    '#622578',
                    '#815093',
                    '#53772b',
                    '#759255',
                    '#8cbfbb',
                    '#a3cbc8',
                ],
            })
            // Drop the canvas once every piece has fallen, so repeated bursts
            // do not stack up invisible canvases on the body.
            .then(() => canvas.remove());
    },
};
</script>
